import {supabase} from '@/integrations/supabase/client';
export type AudioHealthEvent={version:1;incident_id:string;kind:'timeout'|'network'|'http'|'unhealthy'|'recovered';observed_at:string;
 elapsed_ms:number;timeout_ms:number;failure_count:number;http_status:number;visibility:'visible'|'hidden';online:boolean;exception_name:string;
 response?:{request_id?:string;function_version?:string;cf_ray?:string;body_bytes?:number;body_sha256?:string;error_code?:string};
 health?:{status:string;model_loaded:boolean;model_loading:boolean;load_error:boolean}};
// Keep a bounded, memory-only queue when the same connectivity failure prevents
// reporting. No credentials, screenplay text or response bodies enter telemetry.
export function createHealthReporter(send:(event:AudioHealthEvent)=>Promise<boolean>,limit=50){
 const queue:AudioHealthEvent[]=[];let active=false;
 return async(event?:AudioHealthEvent)=>{
  if(event){if(queue.length>=limit)queue.splice(1,1);queue.push(event);}
  if(active)return;active=true;
  try{while(queue.length){if(!await send(queue[0]))break;queue.shift();}}catch{/* Next probe flushes retained events. */}finally{active=false;}
 };
}
export const reportAudioHealth=createHealthReporter(async event=>{
 const result=await supabase.rpc('report_audio_health_event' as never,{p_event:event} as never).abortSignal(AbortSignal.timeout(3000));
 return !result.error&&result.data===true;
});
